var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty"},[(!_vm.hideIcon)?_c('div',{staticClass:"empty__icon"},[_c('PolygonSvg',{attrs:{"icon":"search"}})],1):_vm._e(),_c('div',[_vm._v(_vm._s(_vm.noResultText)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }